import { TopPage } from "@/components/elements/TopPage";
import { Stack, Typography } from "@mui/material";
import { InnerBox } from "@/components/elements/InnerBox";
import { CompanyListTop } from "@/features/company/components/company-list/CompanyListTop";
import { CompanyTable } from "@/features/company/components/company-list/CompanyTable";
import { useCompanyList } from "@/api/services/main/company";
import { usePagination } from "@/hooks/usePagination";
import { useEffect, useRef, useState } from "react";
import { cleanParams } from "@/utils/pieces";
import { TCompanyFilterForm } from "@/features/company/types";
import { Pagination } from "@/components/elements/Pagination";
import { useNavigate } from "react-router-dom";
import { useGetCompanySpecificIndustryList } from "@/api/services/global/master";

export const CompanyListPage = () => {
  const { companySpecificIndustryOptions, isLoading: isIndustryLoading } = useGetCompanySpecificIndustryList();

  const defaultValues: TCompanyFilterForm = {
    keyword: "",
    companySpecificIndustryId: "",
    isArchive: false,
  };

  const [filters, setFilters] = useState<TCompanyFilterForm>({ ...defaultValues });
  const [formValues, setFormValues] = useState<TCompanyFilterForm>({ ...defaultValues });

  const pagReq = usePagination();
  const navigate = useNavigate();

  const { data, isLoading } = useCompanyList({
    ...pagReq,
    ...cleanParams({
      keyword: filters.keyword,
      companySpecificIndustryId: filters.companySpecificIndustryId,
    }),
    isArchive: filters.isArchive ?? false,
  });
  const mountedRef = useRef(false);

  useEffect(() => {
    if (!mountedRef.current) {
      mountedRef.current = true;
      return;
    }

    const allEmpty =
      !formValues.keyword && !formValues.companySpecificIndustryId && !formValues.isArchive;

    if (allEmpty) {
      setFilters(defaultValues);
    }
  }, [formValues]);

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      isArchive: formValues.isArchive,
    }));
    navigateFirstPage();
  }, [formValues.isArchive]);

  const onSubmit = (vals: TCompanyFilterForm) => {
    setFilters(vals);
    navigateFirstPage();
  };

  const navigateFirstPage = () => {
    const nav = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming | undefined;

    if (nav?.type === "navigate") return;

    const params = new URLSearchParams(location.search);

    params.set("page", "1");

    navigate(`/companies?${params.toString()}`);
  };
  return (
    <Stack minHeight="100%">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <TopPage title="所属機関管理" enablePageBack={false} />
      </Stack>
      <InnerBox padding={3} mt={3} showDivider={false} title={<Typography variant="head20Bold">所属機関一覧</Typography>}>
        <Stack flex={1} gap={3}>
          <CompanyListTop
            formValues={formValues}
            onChangeFormValues={setFormValues}
            onSubmit={(vals) => onSubmit(vals)}
            industryOptions={companySpecificIndustryOptions}
            isIndustryLoading={isIndustryLoading}
          />
          <CompanyTable rows={data?.data ?? []} pagination={data?.pagination} isLoading={isLoading} />
          <Pagination totalPage={data?.pagination?.totalPage ?? 1} />
        </Stack>
      </InnerBox>
    </Stack>
  );
};
